import InputField from "../../../components/InputField/InputField";
import Button from "../../../components/Button/Button";

const Settings = ({
  isActiveTab,
  changePassToggler,
  data,
  password,
  errorPassword,
  handleChange,
  handleUploadProfile,
  handleDiscard,
  handleSave,
  handlePassChange,
  handlePassChangeConfirm,
  handlePassPressConfirm,
  handleShowChangePass,
  handleCancelChangePass,
}) => {
  return (
    <>
      <section className={`tabWrapper ${isActiveTab && "active"}`}>
        <div className={`ContainerTabForAllTabData allMentorWrapper`}>
          <div className="Headingforallheader">
            <div className="flex-between w-100">
              <h2 className="heading-2">Edit Profile</h2>
            </div>
          </div>

          <div className="border-btm w-100"></div>

          <div className="bodyDataForallUserdata">
            <div className="AdMainsetting mt-20  overflow">
              <div className="userProfileEdit mulipleFormInputWrap">
                <h4 className="lableHeading">Avatar</h4>
                <div className="leftWrapperPrfile mb25">
                  <div className="userProfileEditTab">
                    <label className="userProfile pointer" for="bgimg">
                      <img
                        src={
                          data?.profileImg
                            ? data?.profileImg
                            : "/assets/img/user1.png"
                        }
                        alt=""
                        className="userimg"
                        onClick={handleUploadProfile}
                      />
                      <img
                        src="/assets/img/edit.png"
                        alt=""
                        className="editimg pointer"
                      />
                    </label>
                  </div>
                  {/* <p className='mt-10 text2'>File types allowed are: jpg, jpeg, png</p> */}
                </div>
              </div>
              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Full Name</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    notImp={true}
                    placeholder={"First Name"}
                    value={data["firstName"]}
                    onChange={handleChange}
                    name={"firstName"}
                  />
                  <InputField
                    notImp={true}
                    placeholder={"Last Name"}
                    value={data["lastName"]}
                    onChange={handleChange}
                    name={"lastName"}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Designation</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    notImp={true}
                    placeholder={"Input designation"}
                    value={data["designation"]}
                    onChange={handleChange}
                    name={"designation"}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Phone Number </h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    type={"tel"}
                    notImp={true}
                    placeholder={"Input contact number"}
                    value={data["mobileNumber"]}
                    onChange={handleChange}
                    name={"mobileNumber"}
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Email </h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    notImp={true}
                    placeholder={"Input email id"}
                    value={data["email"]}
                    onChange={handleChange}
                    name={"email"}
                  />
                </div>
              </div>

              <div className="mulipleFormInputWrap flexbox">
                <h4 className="lableHeading">Linkedin</h4>
                <div className="multipleFormInput flex-center">
                  <InputField
                    notImp={true} placeholder={'Input linkedin profile link'} value={data["linkedin"]} onChange={handleChange} name={"linkedin"}
                  />
                </div>
              </div>

              <div className="border-btm w-100"></div>
              <div className="FooterAddmentors flex flexend">
                <Button
                  name={"Discard"}
                  className={"buttontext GreyFillButton"}
                  onClick={handleDiscard}
                />
                <Button
                  name={"Save Changes"}
                  className="active buttontext BlueFillButton"
                  onClick={handleSave}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`ContainerTabForAllTabData mt-30 tabWrapper ${
            changePassToggler === 1 && "showItpass "
          }`}
        >
          <div className="Headingforallheader">
            <div className="w-100">
              <h2 className="heading-2">Change Password</h2>
            </div>
          </div>

          <div className="border-btm  w-100"> </div>

          <div className="bodyDataForallUserdata">
            <div className="Password flex-between mt-30">
              <h4 className="Passwordtext">
                Password
                <span className="text-grey6">*********</span>
              </h4>
              <Button
                className={"BlueFillButton buttontext"}
                name={"Reset Password"}
                onClick={handleShowChangePass}
              />
            </div>
          </div>
        </div>

        <div
          className={`ContainerTabForAllTabData tabWrapper mt-30 ${
            changePassToggler === 2 && "showItpass "
          }`}
        >
          <div className="Headingforallheader">
            <div className="w-100">
              <h2 className="heading-2">Change Password</h2>
            </div>
          </div>

          <div className="border-btm  w-100"> </div>

          <div className="bodyDataForallUserdata">
            <div className="AdChangePassWrap">
              <div className="mulipleFormInputWrap">
                <h4 className="lableHeading mb-10">Current Password</h4>
                <div className="w-100">
                  <div className="multipleFormInput flex-center">
                    <InputField type={"password"} notImp={true} name={"password"} value={password["password"]} onChange={handlePassChange} errorMessage={errorPassword["password"]} placeholder={'******'} onKeyDown={handlePassPressConfirm} />
                  </div>
                  <p className="text2 mt-12">
                    Password must be at least 6 character
                  </p>
                </div>
              </div>
              <div className="mulipleFormInputWrap">
                <h4 className="lableHeading mb-10">New Password</h4>
                <div className="multipleFormInput flex-center">
                    <InputField type={"password"} notImp={true} name={"newPassword"} value={password["newPassword"]} onChange={handlePassChange} errorMessage={errorPassword["newPassword"]} placeholder={'******'} onKeyDown={handlePassPressConfirm} />
                </div>
              </div>
              <div className="mulipleFormInputWrap">
                <h4 className="lableHeading mb-10">Confirm Password</h4>
                <div className="multipleFormInput flex-center">
                    <InputField type={"password"} notImp={true} name={"confirmPassword"} value={password["confirmPassword"]} onChange={handlePassChange} errorMessage={errorPassword["confirmPassword"]} placeholder={'******'} onKeyDown={handlePassPressConfirm} />
                </div>
              </div>
            </div>
            <div className="FooterAddmentors flex mt-30 gap-20">
              <Button
                className={"GreyFillButton  buttontext"}
                name={"Discard"}
                onClick={handleCancelChangePass}
              />
              <Button
                className={"BlueFillButton buttontext"}
                name={"Update Password"}
                onClick={handlePassChangeConfirm}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Settings;
